<template>
	<div class="container row-v2">
		<div class="col">
			<div class="col__box">
				Series: {{series.name}}
			</div>
		</div>
	</div>
</template>

<script>
	export default {

		name: 'series-show',

		data () {
			return {
				series: {
					name: '',
				}
			}
		},
		methods: {
			load() {
				window.api.series.find(this.$route.params.slug)
				.then(series => {
					this.series = series;
				})
			}
		},
		created() {
			this.load();
		},
		watch() {
			this.load();
		}
	}
</script>

